(() => {
  const normalize = value => value.toUpperCase().replace(/[\s/\u2010-\u2015-]/g, '');
  function supports(p, pos) { return !pos || p.position === pos || p.position === 'Front/Rear'; }
  function oppositePosition(p, selected) {
    const current = p.position === 'Front/Rear' ? selected : p.position;
    return current === 'Front' ? 'Rear' : current === 'Rear' ? 'Front' : '';
  }
  function eligibleApplications(chosen, selected, pairs, products) {
    const opposite = oppositePosition(chosen, selected);
    if (!chosen.available || !opposite) return [];
    return pairs.filter(app => {
      const chosenKey = opposite === 'Rear' ? 'front_sku' : 'rear_sku';
      const mateKey = opposite === 'Rear' ? 'rear_sku' : 'front_sku';
      const mate = products.find(p => p.sku === app[mateKey]);
      return app[chosenKey] === chosen.sku && mate && mate.available && supports(mate, opposite) && mate.brand === chosen.brand;
    });
  }
  function matchingTires(chosen, selected, pairs, products) {
    const opposite = oppositePosition(chosen, selected);
    const key = opposite === 'Rear' ? 'rear_sku' : 'front_sku';
    const skus = new Set(eligibleApplications(chosen, selected, pairs, products).map(app => app[key]));
    return products.filter(p => skus.has(p.sku));
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {normalize, supports, oppositePosition, eligibleApplications, matchingTires};
  if (typeof document === 'undefined') return;
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const data = JSON.parse(root.querySelector('[data-catalog]').textContent);
    const products = data.products.filter(p => p.available);
    const bySku = new Map(products.map(p => [p.sku, p]));
    const form = root.querySelector('form');
    const size = form.elements.size, position = form.elements.position, brand = form.elements.brand;
    const results = root.querySelector('[data-results]'), count = root.querySelector('[data-count]');
    const panel = root.querySelector('[data-pair-panel]');
    const pairSelect = root.querySelector('[data-bike]'), mateResults = root.querySelector('[data-mates]');
    let chosen = null, chosenPosition = '', eligible = [];
    function option(select, value, text) { const o = document.createElement('option'); o.value = value; o.textContent = text; select.append(o); }
    [...new Set(products.map(p => p.size))].sort().forEach(s => option(root.querySelector('[data-sizes]'), s, s));
    [...new Set(products.map(p => p.brand))].sort().forEach(b => option(brand, b, b));
    function update() {
      let shown = 0;
      let matchSkus = null;
      if (chosen) {
        const apps = pairSelect.value === '' ? eligible : [eligible[Number(pairSelect.value)]].filter(Boolean);
        matchSkus = new Set(matchingTires(chosen, chosenPosition, apps, products).map(p => p.sku));
      }
      results.querySelectorAll('[data-sku]').forEach(card => {
        const p = bySku.get(card.dataset.sku);
        const visible = p && (!matchSkus || matchSkus.has(p.sku)) && (!size.value || normalize(size.value) === normalize(p.size)) && supports(p, position.value) && (!brand.value || brand.value === p.brand);
        card.hidden = !visible;
        if (visible) shown++;
      });
      count.textContent = chosen ? `${shown} matching ${oppositePosition(chosen, chosenPosition).toLowerCase()} tire${shown === 1 ? '' : 's'}${pairSelect.value === '' ? ' — confirm your bike and year above' : ''}` : `${shown} in-stock tire option${shown === 1 ? '' : 's'}`;
    }
    function mates() {
      mateResults.replaceChildren();
      update();
      if (!chosen || pairSelect.value === '') return;
      const app = eligible[Number(pairSelect.value)];
      if (!app) return;
      const opposite = oppositePosition(chosen, chosenPosition);
      const mate = bySku.get(opposite === 'Rear' ? app.rear_sku : app.front_sku);
      if (!mate || !mate.available) return;
      const note = document.createElement('p');
      note.textContent = 'Manufacturer-listed pairing for this model and year. Confirm stock wheels, load/speed ratings and tube requirements before ordering.';
      const link = document.createElement('a');
      link.href = mate.url;
      link.textContent = `View matching ${opposite.toLowerCase()} tire: ${mate.brand} ${mate.family} — ${mate.size} — ${mate.price}`;
      mateResults.append(note);
      if (app.notes) { const detail = document.createElement('p'); detail.textContent = app.notes; mateResults.append(detail); }
      mateResults.append(link);
    }
    function choose(sku) {
      chosen = bySku.get(sku);
      if (!chosen) return;
      chosenPosition = position.value;
      eligible = eligibleApplications(chosen, chosenPosition, data.pairs, products);
      if (!eligible.length) { panel.hidden = true; chosen = null; results.querySelectorAll('[data-sku]').forEach(card => { card.hidden = true; }); count.textContent = 'No verified in-stock matching tire available.'; return; }
      position.value = oppositePosition(chosen, chosenPosition);
      size.value = '';
      brand.value = chosen.brand;
      panel.hidden = false;
      root.querySelector('[data-chosen]').textContent = `Find matching ${oppositePosition(chosen, chosenPosition).toLowerCase()} tire`;
      pairSelect.replaceChildren();
      option(pairSelect, '', 'Choose your bike and year');
      eligible.forEach((app, i) => option(pairSelect, String(i), `${app.year_start === app.year_end ? app.year_start : app.year_start + '–' + app.year_end} ${app.model}`));
      mateResults.replaceChildren();
      update();
      pairSelect.focus();
      panel.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
    }
    form.addEventListener('submit', e => { e.preventDefault(); panel.hidden = true; chosen = null; update(); });
    form.addEventListener('change', () => { panel.hidden = true; chosen = null; update(); });
    pairSelect.addEventListener('change', mates);
    root.querySelector('[data-pair-close]').addEventListener('click', () => { panel.hidden = true; chosen = null; update(); });
    const qs = new URLSearchParams(location.search);
    if (qs.has('size')) size.value = qs.get('size');
    if (qs.has('position')) position.value = qs.get('position');
    if (data.initialBrand) brand.value = data.initialBrand;
    if (data.initialPosition) position.value = data.initialPosition;
    update();
    if (qs.has('pair')) choose(qs.get('pair'));
  }
  function initProduct(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const select = root.querySelector('select'), link = root.querySelector('[data-match-link]');
    if (!select || !link) return;
    function update() {
      const opposite = oppositePosition({position: 'Front/Rear'}, select.value);
      link.hidden = !opposite;
      if (opposite) {
        const url = new URL(link.dataset.baseUrl, location.origin);
        url.searchParams.set('position', select.value);
        url.hash = 'tire-finder';
        link.href = url.href;
        link.textContent = `Find matching ${opposite.toLowerCase()} tire`;
      }
    }
    select.addEventListener('change', update); update();
  }
  function mount(scope) {
    scope.querySelectorAll('[data-hdp-tire-match]').forEach(initProduct);
    scope.querySelectorAll('[data-hdp-tires]').forEach(init);
  }
  mount(document);
  document.addEventListener('shopify:section:load', e => mount(e.target));
})();
